module.exports = __webpack_public_path__ + "img/18.d34ff963.png";